window.dn = window.dn || {};

/** All methods related to messages */
(function (message, $, undefined)
{
    // For tracking/canceling pending ajax requests
    message.AjaxBookmarkInProgress = {};
    message.AjaxVoteInProgress = {};

    /**
     * Storing data about the message currently being viewed.
     */
    message.Current = {};

    /**
     * MessageStatus enum, based on Message.MessageStatus in C#.
     */
    message.Status = 
    {
        Default: 0,
        Unknown: 100,
        Wanted: 200,
        OemNotification: 500,
        Update: 1000,
        Delay: 2000,
        UnresolvedClosure: 2500,
        Rejection: 3000,
        Failure: 3100,
        Resolution: 4000,
        Success: 4100,
        Contribution: 4200
    };

    /**
     * Primary color dark version (i.e. generally the background color of type tag boxes) conveying message status.
     * 
     * NOTE: Keep this in sync with Message.cs.
     */
    message.StatusColorsPrimary = {};
    message.StatusColorsPrimary[message.Status.Default] = "939597";
    message.StatusColorsPrimary[message.Status.Unknown] = "939597";
    message.StatusColorsPrimary[message.Status.Wanted] = "939597";
    message.StatusColorsPrimary[message.Status.OemNotification] = "17a2b8";
    message.StatusColorsPrimary[message.Status.Update] = "17a2b8";
    message.StatusColorsPrimary[message.Status.Delay] = "f0ad4e";
    message.StatusColorsPrimary[message.Status.UnresolvedClosure] = "f0ad4e";
    message.StatusColorsPrimary[message.Status.Rejection] = "d9534f";
    message.StatusColorsPrimary[message.Status.Failure] = "d9534f";
    message.StatusColorsPrimary[message.Status.Resolution] = "02b875";
    message.StatusColorsPrimary[message.Status.Success] = "02b875";
    message.StatusColorsPrimary[message.Status.Contribution] = "02b875";

    /**
     * Primary color light version (i.e. generally the background color of reply messages) conveying message status.
     * 
     * NOTE: Keep this in sync with Message.cs.
     */
    message.StatusColorsPrimaryLight = {};
    message.StatusColorsPrimaryLight[message.Status.Default] = "f8f8f8";
    message.StatusColorsPrimaryLight[message.Status.Unknown] = "f8f8f8";
    message.StatusColorsPrimaryLight[message.Status.Wanted] = "f8f8f8";
    message.StatusColorsPrimaryLight[message.Status.OemNotification] = "d1ecf1";
    message.StatusColorsPrimaryLight[message.Status.Update] = "d1ecf1";
    message.StatusColorsPrimaryLight[message.Status.Delay] = "fcefdc";
    message.StatusColorsPrimaryLight[message.Status.UnresolvedClosure] = "fcefdc";
    message.StatusColorsPrimaryLight[message.Status.Rejection] = "f7dddc";
    message.StatusColorsPrimaryLight[message.Status.Failure] = "f7dddc";
    message.StatusColorsPrimaryLight[message.Status.Resolution] = "ccf1e3";
    message.StatusColorsPrimaryLight[message.Status.Success] = "ccf1e3";
    message.StatusColorsPrimaryLight[message.Status.Contribution] = "ccf1e3";

    /**
     * Primary color (i.e. generally the foreground color) for message status.
     * 
     * NOTE: Keep this in sync with Message.cs.
     */
    message.StatusColorsText = {};
    message.StatusColorsText[message.Status.Default] = "ffffff";
    message.StatusColorsText[message.Status.Unknown] = "ffffff";
    message.StatusColorsText[message.Status.Wanted] = "ffffff";
    message.StatusColorsText[message.Status.OemNotification] = "ffffff";
    message.StatusColorsText[message.Status.Update] = "ffffff";
    message.StatusColorsText[message.Status.Delay] = "555658";
    message.StatusColorsText[message.Status.UnresolvedClosure] = "555658";
    message.StatusColorsText[message.Status.Rejection] = "ffffff";
    message.StatusColorsText[message.Status.Failure] = "ffffff";
    message.StatusColorsText[message.Status.Resolution] = "ffffff";
    message.StatusColorsText[message.Status.Success] = "ffffff";
    message.StatusColorsText[message.Status.Contribution] = "ffffff";

    /**
     * This maps MessageStatus enum to dropdown selection values.
     */
    message.StatusDropdown = {};
    message.StatusDropdown[message.Status.Default] = "Default";
    message.StatusDropdown[message.Status.Unknown] = "Unknown";
    message.StatusDropdown[message.Status.Wanted] = "Wanted";
    message.StatusDropdown[message.Status.OemNotification] = "OEM Notification";
    message.StatusDropdown[message.Status.Update] = "Update";
    message.StatusDropdown[message.Status.Delay] = "Delay";
    message.StatusDropdown[message.Status.UnresolvedClosure] = "Unresolved Closure";
    message.StatusDropdown[message.Status.Rejection] = "Rejection";
    message.StatusDropdown[message.Status.Failure] = "Failure";
    message.StatusDropdown[message.Status.Resolution] = "Resolution";
    message.StatusDropdown[message.Status.Success] = "Success";
    message.StatusDropdown[message.Status.Contribution] = "Contribution";

    /**
     * MessageStatus explanations in english, used on initial status. {0} will be replaced by
     * the StatusNoun for the current message type, e.g. Discussion, Question, etc.
     */
    message.StatusExplanationInitial = {};
    message.StatusExplanationInitial[message.Status.Default] = '';
    message.StatusExplanationInitial[message.Status.Unknown] = '<b>Unknown</b> is the status to use if you need help with your <i>{0}</i>, and <u>will</u> notify most members.';
    message.StatusExplanationInitial[message.Status.Wanted] = '<b>Wanted</b> is the status to use if you need a <i>{0}</i>, and <u>will</u> notify most members.';
    message.StatusExplanationInitial[message.Status.Failure] = '<b>Failed</b> will post your <i>{0}</i> in a closed state, and will <u>not</u> notify most members, though it will appear in search results.';
    message.StatusExplanationInitial[message.Status.Resolution] = '<b>Resolved</b> will post your <i>{0}</i> in a closed state, and will <u>not</u> notify most members, though it will appear in search results.';
    message.StatusExplanationInitial[message.Status.Success] = '<b>Succeeded</b> will post your <i>{0}</i> in a closed state, and will <u>not</u> notify most members, though it will appear in search results.';
    message.StatusExplanationInitial[message.Status.Contribution] = '<b>Contributed</b> let\'s you share your <i>{0}</i> <u>without</u> notifying most members, though it will appear in search results.';

    /**
     * MessageStatus explanations in english, used on reply forms. {0} will be replaced by
     * the StatusNoun for the current message type, e.g. Discussion, Question, etc.
     */
    message.StatusExplanation = {};
    message.StatusExplanation[message.Status.Default] = '';
    message.StatusExplanation[message.Status.Unknown] = '<b>Unknown</b> is the status to use if you still need help with your <i>{0}</i>.';
    message.StatusExplanation[message.Status.Wanted] = '<b>Wanted</b> is the status to use if you still need a <i>{0}</i>.';
    message.StatusExplanation[message.Status.OemNotification] = "<b>OEM Notifications</b> are intended to signal that the OEM has been notified of this <i>{0}</i>.";
    message.StatusExplanation[message.Status.Update] = '<b>Updates</b> are intended to provide additional information to all participants, and will be highlighted prominently in this <i>{0}</i>. If you are correcting mistakes in your original message, we would recommend you edit your message instead of replying to it.';
    message.StatusExplanation[message.Status.Delay] = '<b>Delays</b> are intended to notify participants why your <i>{0}</i> cannot be resolved at this time, and will flag your <i>{0}</i> as "Delayed." This message will be highlighted in the discussion.';
    message.StatusExplanation[message.Status.UnresolvedClosure] = "<b>Unresolved Closures</b> are intended to notify participants that the <i>{0}</i> has been closed, but probably not in a way that satisfies the person that reported the <i>{0}</i>.";
    message.StatusExplanation[message.Status.Rejection] = '<b>Rejections</b> will cause this <i>{0}</i> to be closed and flagged as "Rejected," hiding it from the message streams.';
    message.StatusExplanation[message.Status.Failure] = '<b>Failure</b> will close your <i>{0}</i> as "Failed," and will notify all participants of this change. In addition, this reply will be highlighted in the discussion.';
    message.StatusExplanation[message.Status.Resolution] = '<b>Resolutions</b> will close your <i>{0}</i> as "Resolved," and will notify all participants of this change. In addition, this reply will be highlighted in the discussion. In addition to posting a resolution like this, you can upvote and tag any reply as a Resolution.';
    message.StatusExplanation[message.Status.Success] = '<b>Success</b> will close your <i>{0}</i> as "Succeeded," and will notify all participants of this change. In addition, this reply will be highlighted in the discussion.';
    message.StatusExplanation[message.Status.Contribution] = '<b>Contribution</b> will close your <i>{0}</i> as "Contributed," and will notify all participants of this change. In addition, this reply will be highlighted in the discussion.';

    /**
     * This maps MessageStatus enum to noun form.
     */
    message.StatusNouns = {};
    message.StatusNouns[message.Status.Default] = "";
    message.StatusNouns[message.Status.Unknown] = "";
    message.StatusNouns[message.Status.Wanted] = "";
    message.StatusNouns[message.Status.OemNotification] = "OEM Notification";
    message.StatusNouns[message.Status.Update] = "Update";
    message.StatusNouns[message.Status.Delay] = "Delay";
    message.StatusNouns[message.Status.UnresolvedClosure] = "Unresolved Closure";
    message.StatusNouns[message.Status.Rejection] = "Rejection";
    message.StatusNouns[message.Status.Failure] = "Failure";
    message.StatusNouns[message.Status.Resolution] = "Resolution";
    message.StatusNouns[message.Status.Success] = "Success";
    message.StatusNouns[message.Status.Contribution] = "Contribution";

    /**
     * MessageStatus enum, reversed, based on Message.MessageStatus in C#.
     */
    message.StatusReverse = {};
    message.StatusReverse[message.Status.Default] = "Default";
    message.StatusReverse[message.Status.Unknown] = "Unknown";
    message.StatusReverse[message.Status.Wanted] = "Wanted";
    message.StatusReverse[message.Status.OemNotification] = "OemNotification";
    message.StatusReverse[message.Status.Update] = "Update";
    message.StatusReverse[message.Status.Delay] = "Delay";
    message.StatusReverse[message.Status.UnresolvedClosure] = "UnresolvedClosure";
    message.StatusReverse[message.Status.Rejection] = "Rejection";
    message.StatusReverse[message.Status.Failure] = "Failure";
    message.StatusReverse[message.Status.Resolution] = "Resolution";
    message.StatusReverse[message.Status.Success] = "Success";
    message.StatusReverse[message.Status.Contribution] = "Contribution";

    /**
     * This maps MessageStatus enum to verb form, e.g. Resolution -> Resolved.
     * 
     * Status on the main discussion root message uses the same field as the replies, `Status`, but
     * instead of it being the noun form (e.g. "Resolution"), we use it as a verb (e.g. "Resolved").
     * 
     * NOTE: Keep this in sync with Message.cs.
     */
    message.StatusVerbs = {};
    message.StatusVerbs[message.Status.Default] = "Unsolved";
    message.StatusVerbs[message.Status.Unknown] = "Unknown";
    message.StatusVerbs[message.Status.Wanted] = "Wanted";
    message.StatusVerbs[message.Status.OemNotification] = "OEM Notified";
    message.StatusVerbs[message.Status.Update] = "Updated";
    message.StatusVerbs[message.Status.Delay] = "Delayed";
    message.StatusVerbs[message.Status.UnresolvedClosure] = "Closed/Unresolved";
    message.StatusVerbs[message.Status.Rejection] = "Rejected";
    message.StatusVerbs[message.Status.Failure] = "Failed";
    message.StatusVerbs[message.Status.Resolution] = "Resolved";
    message.StatusVerbs[message.Status.Success] = "Succeeded";
    message.StatusVerbs[message.Status.Contribution] = "Contributed";

    /**
     * This maps MessageStatus enum to whether or not we should show this type to
     * TypeManagers only when replying, or if it's OK to show the option to the author as well.
     */
    message.StatusTypeManagersOnly = {};
    message.StatusTypeManagersOnly[message.Status.Default] = false;
    message.StatusTypeManagersOnly[message.Status.Unknown] = true;
    message.StatusTypeManagersOnly[message.Status.Wanted] = true;
    message.StatusTypeManagersOnly[message.Status.OemNotification] = true;
    message.StatusTypeManagersOnly[message.Status.Update] = false;
    message.StatusTypeManagersOnly[message.Status.Delay] = false;
    message.StatusTypeManagersOnly[message.Status.UnresolvedClosure] = true;
    message.StatusTypeManagersOnly[message.Status.Rejection] = true;
    message.StatusTypeManagersOnly[message.Status.Failure] = false;
    message.StatusTypeManagersOnly[message.Status.Resolution] = false;
    message.StatusTypeManagersOnly[message.Status.Success] = false;
    message.StatusTypeManagersOnly[message.Status.Contribution] = false;

    /**
     * Maps MessageStatus enum to any types that should not be used on replies.
     */
    message.StatusNotOnReplies = {};
    // message.StatusNotOnReplies[message.Status.Default] = false;
    message.StatusNotOnReplies[message.Status.Unknown] = true;
    message.StatusNotOnReplies[message.Status.Wanted] = true;
    // message.StatusNotOnReplies[message.Status.OemNotification] = true;
    // message.StatusNotOnReplies[message.Status.Update] = false;
    // message.StatusNotOnReplies[message.Status.Delay] = false;
    // message.StatusNotOnReplies[message.Status.UnresolvedClosure] = true;
    // message.StatusNotOnReplies[message.Status.Rejection] = true;
    // message.StatusNotOnReplies[message.Status.Failure] = false;
    // message.StatusNotOnReplies[message.Status.Resolution] = false;
    // message.StatusNotOnReplies[message.Status.Success] = false;
    // message.StatusNotOnReplies[message.Status.Contribution] = false;

    /**
     * Add event handlers to a message once the messages have been rendered. 
     * This can be called multiple times, such as after dynamically inserting new
     * replies, because we add `dn-event-{event}` classes to each element that we
     * attach an event handler to, so that we don't worry about doing it twice.
     * 
     * NOTE: This method is similar to discussion.AddEventHandlers, but the difference
     * is that it contains any event handlers that would be rendered on a message 
     * regardless of whether it's a discussion or a chat conversation.
     */
    message.AddEventHandlers = function() 
    {
        // add click-handlers to the visible attachments
        $("div.dn-file-wrapper:not(.dn-event-click)").click(function(e) 
        {
            e.preventDefault();     // don't let the default event happen
            e.stopPropagation();    // don't let this bubble up
            dn.ShowFileInGallery($(this));
        })
        .addClass("dn-event-click");
    };

    /**
     * Toggles bookmarking of a discussion off/on, referring to the data stored in the
     * data-bookmarked attribute on the #data-<messagekey> element.
     *
     * @param {string} messageKey   - the message to bookmark/unbookmark
     * @param {element} $element    - the element that triggered the request
     */
    message.Bookmark = dn.Debounce(function(messageKey, $element) 
    {
        // they want to do the opposite of whatever they're currently doing
        var wantsToBookmark = !($("#data-" + messageKey).data("bookmarked"));
        var $message = $('div.dn-message[data-messagekey="' + messageKey + '"]');
        var authorUserKey = $message.data('userkey');

        if (authorUserKey != dn.user.UserKey)
        {
            // Don't let authors tag their own messages.
            if (wantsToBookmark)
            {
                // adding a bookmark, so let them tag the message too
                dn.tag.EditTags({messageKey: messageKey, $element: $element, tagEvent: dn.tag.TagEvent.Bookmark});
            }
            else if ($message.data('usertags-count') > 0)
            {
                // if removing a bookmark, only show the tag box if they have existing tags they may want to edit
                dn.tag.EditTags({messageKey: messageKey, $element: $element, tagEvent: dn.tag.TagEvent.BookmarkOff});
            }
        }

        // immediately update button graphics and bookmark status, to make the UI seem snappy (waiting for the ajax request to return is pretty slow)
        message.UpdateBookmarkUI(messageKey, wantsToBookmark);

        // kill existing ajax requests and 'overwrite' with latest preference
        if (message.AjaxBookmarkInProgress[messageKey]) {
            message.AjaxBookmarkInProgress[messageKey].abort();
        }

        // Send a POST or DELETE to the server, depending on whether we are bookmarking or un-bookmarking
        message.AjaxBookmarkInProgress[messageKey] = jQuery.ajax({
            url: "/api/v1/message/" + messageKey + "/bookmark",
            type: wantsToBookmark ? "POST" : "DELETE",
            contentType:"application/json; charset=utf-8"
        })
        .done(function (result) 
        {
            delete message.AjaxBookmarkInProgress[messageKey];
            message.UpdateBookmarkUI(messageKey, result && result[messageKey]);
        })
        .fail(function (xhr, textStatus, errorThrown) 
        {
            delete message.AjaxBookmarkInProgress[messageKey];

            // it failed, so undo the ui
            message.UpdateBookmarkUI(messageKey, !wantsToBookmark);

            if (errorThrown !== 'abort' && !dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
            {
                dn.ShowErrorForElement($element, dn.FormatApiError(xhr.responseJSON), 'bottom');

                // hide any tag editing, assuming this failure isn't just an ajax abort
                setTimeout(function() { $element.popover('hide') }, 500);
            }
        });
    }, 200, true); // execute immediately, but not again for at least 200 ms

    /**
     * Retrieve the tags set for this message. Will return JSON like this:
     * 
     * {
     *     MessageTags: [
     *         {...}
     *     ],
     *     UserTags: [
     *         {...}
     *     ]
     * }
     * 
     * @param {string} opt.messageKey   - MessageKey of the message to be tagged.
     * @param {func} opt.onSuccess      - Callback function we'll pass the message's tag info to.
     * @param {func} opt.onFailure      - (Optional) callback function we'll pass any failure info to.
     */
    message.GetTags = dn.Debounce(function(opt) 
    {
        $.get("/api/v1/message/" + opt.messageKey + "/tags")
        .done(function(tags) 
        {
            if (opt.onSuccess)
            {
                opt.tags = tags;
                opt.onSuccess(opt);
            }
        })
        .fail(function(xhr, textStatus, errorThrown) 
        {
            if (opt.onFailure)
            {
                opt.onFailure(xhr, textStatus, errorThrown);
            }
        });

    }, 200, true); // execute immediately, but not again for at least 200 ms

    message.HighlightReply = function($reply)
    {
        // if this is a solved bounty we want it to be green, else make it blue
        message.UnhideSubthread($reply);
        return $reply.addClass("dn-message-highlighted");
    };

    /**
     * Scrolls to the first desired reply. Wrapped in debounce because
     * we may also call this multiple times as embed iframes are loading.
     */
    message.ScrollToReply = dn.Debounce(function() 
    {
        if (dn.user.IsLoggedIn)
        {
            // scroll to selected message (from query string)
            if ($('*[data-selected="True"]').length > 0) 
            {
                var $selectedMessage = $('*[data-selected="True"]');
                $selectedMessage.removeClass("collapse-reply");

                message.HighlightReply($selectedMessage);

                $('html, body').animate({
                    scrollTop: $selectedMessage.offset().top - 50
                }, 750);
            }
            else
            {
                // Scroll down to the first expanded reply, if there is one
                if ($('div.dn-message').data("lastvisit") > 100000)
                {
                    var $firstExpandedReply = $('.dn-reply').not('.collapse-reply').first();
                    if ($firstExpandedReply.length != 0)
                    {
                        $('html, body').animate({
                            scrollTop: $firstExpandedReply.offset().top - 50
                        }, 750);
                    }
                }
            }
        }
    }, 200);

    /**
     * Set the tags on a message by a specific user. If the user has previously tagged the
     * message, and these tags are not included in this request, they will be removed.
     * 
     * @param {string} opt.messageKey   - MessageKey of the message to be tagged.
     * @param {array} opt.tags          - Array of TagIds this user wants assigned to the given message.
     * @param {int} opt.tagEvent        - The event that led to this tag request, e.g. dn.tag.TagEvent.Upvote, 
     *                                    Downvote, or Bookmark.
     * @param {func} opt.onSuccess      - Callback function we'll pass the message's tag info to.
     * @param {func} opt.onFailure      - (Optional) callback function we'll pass any failure info to.
     */
    message.Tag = dn.Debounce(function(opt) 
    {
        $.postJSON("/api/v1/message/" + opt.messageKey + "/tags", 
        {
            Tags: opt.tags,
            TagEvent: opt.tagEvent
        })
        .done(function(tags) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(tags);
            }
        })
        .fail(function(xhr, textStatus, errorThrown) 
        {
            if (opt.onFailure)
            {
                opt.onFailure(xhr, textStatus, errorThrown);
            }
        });

    }, 200, true); // execute immediately, but not again for at least 200 ms

    /**
     * Use our embedding service to render all embeds (unfurled links, etc).
     * This can be called multiple times, such as after a new reply is inserted.
     * 
     * @param ($element) $startFromElement  - (Optional) A parent element to start 
     *                                        searching in, defaults to $(document).
     */
    message.UnfurlLinks = function($startFromElement)
    {
        ($startFromElement || $(document)).find('a[data-iframely-url]:not(.dn-embed-processed)')
        .each(function (index, element) 
        {
            console.debug('Unfurl', element);
            iframely.load(element, $(element).attr('url'));
            $(element).addClass("dn-embed-processed"); // so we don't process it twice
        });
    };

    /**
     * Unhide the given reply and all of its ancestors.
     * 
     * Start at the given $reply, unhide it, and then unhide all of its parents.
     * Each reply has a data-parentkey, which is the id of the parent reply. Use
     * that to traverse the tree and unhide all of the parents.
     */
    message.UnhideSubthread = function($reply)
    {
        $reply.removeClass("dn-hide-reply ");
        var parentKey = $reply.data("parentkey");
        while (parentKey)
        {
            var $parent = $('div.dn-reply[data-messagekey="' + parentKey + '"]');
            $parent.removeClass("dn-hide-reply ");
            parentKey = $parent.data("parentkey");
        }
    };

    /**
     * Vote on the given message. If the same vote is passed in that is already
     * set for this message, it means they want to toggle that vote OFF.
     *
     * @param {string}  messageKey  - the message to vote on
     * @param {boolean} newVote     - what they want their new vote to be
     * @param {element} $element    - The element to tie the error message to.
     * @param {func}    onSuccess   - Callback function we'll pass the message's vote info to.
     * @param {func}    onFailure   - (Optional) callback function we'll pass any failure info to.
     */
    message.Vote = dn.Debounce(function(messageKey, newVote, $element, onSuccess, onFailure) 
    {
        // get the current vote count and user vote
        var currentVoteTotal = parseInt($("#data-" + messageKey).data("votetotal"));
        var currentVote = parseInt($("#data-" + messageKey).data("currentvote"));

        // sanity check (we also do this server side)
        if (newVote > 1)
        {
            newVote = 1;
        }
        else if (newVote < -1)
        {
            newVote = -1;
        }

        // if they pass the same vote in, it means they want to toggle it off
        if (newVote == currentVote)
        {
            // undo their existing vote
            newVote = 0;

            if ($('div.dn-message[data-messagekey="' + messageKey + '"]').data('usertags-count') > 0)
            {
                // They're clearing their vote, if they have any tags, let them edit them if they have any.
                dn.tag.EditTags({messageKey: messageKey, $element: $element, tagEvent: currentVote > 0 ? dn.tag.TagEvent.UpvoteOff : dn.tag.TagEvent.DownvoteOff});
            }
        }
        else
        {
            // They're not just clearing a vote, they're setting one, so let them tag
            dn.tag.EditTags({messageKey: messageKey, $element: $element, tagEvent: newVote > 0 ? dn.tag.TagEvent.Upvote : dn.tag.TagEvent.Downvote});
        }

        var newVoteTotal = currentVoteTotal + newVote - currentVote;

        // Update our UI immediately
        message.UpdateVoteUI(messageKey, newVoteTotal, newVote);

        // kill existing ajax requests and 'overwrite' with latest vote
        if (message.AjaxVoteInProgress[messageKey]) {
            message.AjaxVoteInProgress[messageKey].abort();
        }

        // post to server
        message.AjaxVoteInProgress[messageKey] = $.postJSON("/api/v1/message/" + messageKey + "/vote/" + newVote)
        .done(function (result) 
        {
            delete message.AjaxVoteInProgress[messageKey];
            if (result)
            {
                // Just in case the end results differ, update our UI again
                message.UpdateVoteUI(messageKey, result.Votes, result.UserVote);

                if (onSuccess)
                {
                    onSuccess(result);
                }
            }
        })
        .fail(function (xhr, textStatus, errorThrown) 
        {
            delete message.AjaxVoteInProgress[messageKey];

            // Oof, undo the change
            message.UpdateVoteUI(messageKey, currentVoteTotal, currentVote);

            if (errorThrown !== 'abort' && !dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown))
            {
                // Show them the error, unless it's just an ajax abort
                var body = dn.FormatApiError(xhr.responseJSON);
                dn.ShowModal({ title: "Vote Problem", body: body, preserveOpenModals: true });

                // hide any tag editing, assuming this failure isn't just an ajax abort
                setTimeout(function() { $element.popover('hide') }, 500);
            }

            if (onFailure)
            {
                onFailure(xhr, textStatus, errorThrown);
            }
        });

    }, 200, true); // execute immediately, but not again for at least 200 ms

    /**
     * Update the bookmark UI for the given message.
     * 
     * @param {string} messageKey - The identifier for the message UI to update.
     * @param {bool} isBookmarked - Whether or not the user is now bookmarking this message.
     */
    message.UpdateBookmarkUI = function(messageKey, isBookmarked)
    {
        $("#data-" + messageKey).data("bookmarked", isBookmarked);

        if (isBookmarked) 
        {
            $('#bookmark-' + messageKey).addClass('dn-pressed').find('svg[data-fa-i2svg]').attr('data-prefix', 'fas');
        } 
        else 
        { 
            $('#bookmark-' + messageKey).removeClass('dn-pressed').find('svg[data-fa-i2svg]').attr('data-prefix', 'far');
        }
    };

     /**
     * Update the mute icon UI for the given message.
     *      
     * @param {string} messageKey - The identifier for the message UI to update.
     * @param {bool} isMuted - Whether or not the user has muted this message
     */
     message.UpdateMuteUI = function(messageKey, isMuted)
     {
        $("#mute-" + messageKey).data("muted", isMuted);
        if (isMuted)
        {
            $('#mute-' + messageKey).addClass('dn-pressed').find('svg[data-fa-i2svg]').attr('data-prefix', 'fas' );
        }
        else 
        {
            $('#mute-' + messageKey).removeClass('dn-pressed').find('svg[data-fa-i2svg]').attr('data-prefix', 'far');
        }
     };


    /**
     * Update the root message's status with this new status, if this discussion is the kind 
     * that has a status associated with the type, e.g. Updated, Delayed, Resolved, etc. 
     */
    message.UpdateRootStatus = function(status)
    {
        var $typeStatus = $('.dn-type-status');
        if ($typeStatus.length)
        {
            // This is one of those types of messages, so let's set the new status name/coloring
            $typeStatus.text(dn.message.StatusVerbs[status]);
            $typeStatus.css("color", "#" + dn.message.StatusColorsText[status]).css("background-color", "#" + dn.message.StatusColorsPrimary[status]);
        }
    };

    /**
     * Update the voting UI for the given message.
     * 
     * @param {string} messageKey - The identifier for the message voting UI to update.
     * @param {int} voteTotal - The current total votes on this message.
     * @param {int} userVote - The user's new vote on this message, either -1, +1, or 0.
     */
    message.UpdateVoteUI = function(messageKey, voteTotal, userVote)
    {
        $("#data-" + messageKey).data("votetotal", voteTotal);
        $("#data-" + messageKey).data("currentvote", userVote);

        var voteText = (voteTotal > 0 ? '+' : '') + voteTotal;
        $("#" + messageKey + "-vote-count").html(voteText);

        if (userVote > 0)       // +1
        {
            $("#" + messageKey + "-upvote").find('svg[data-fa-i2svg]').attr('data-prefix', 'fas');
            $("#" + messageKey + "-downvote").find('svg[data-fa-i2svg]').attr('data-prefix', 'fal');
        }
        else if (userVote < 0)  // -1
        {
            $("#" + messageKey + "-upvote").find('svg[data-fa-i2svg]').attr('data-prefix', 'fal');
            $("#" + messageKey + "-downvote").find('svg[data-fa-i2svg]').attr('data-prefix', 'fas');
        }
        else                    // OFF
        {
            $("#" + messageKey + "-upvote").find('svg[data-fa-i2svg]').attr('data-prefix', 'fal');
            $("#" + messageKey + "-downvote").find('svg[data-fa-i2svg]').attr('data-prefix', 'fal');
        }
    }

    $(document).ready
    (
        function ($)
        {
            // Process any queued functions now that the namespace is ready.
            dn.ProcessQueuedFunctions('dn.message');
        }
    );

}(window.dn.message = window.dn.message || {}, jQuery));
